module.exports = __webpack_public_path__ + "img/ysyx.33799090.png";